import ArvydasImg from "../../assets/images/reviews/Arvydas.png";
import MantasImg from "../../assets/images/reviews/Mantas.png";
import DovydasImg from "../../assets/images/reviews/Dovydas.png";
import VytautasImg from "../../assets/images/reviews/Vytautas.png";
import JonasImg from "../../assets/images/reviews/Jonas.png";
import GintvileImg from "../../assets/images/reviews/Gintvile.png";
import BrigitaImg from "../../assets/images/reviews/Brigita.png";
import RutaImg from "../../assets/images/reviews/Ruta.png";
import SimonaImg from "../../assets/images/reviews/Simona.png";
import MilanaImg from "../../assets/images/reviews/Milana.png";
import EmilėImg from "../../assets/images/reviews/Emilė.png";
import LinasImg from "../../assets/images/reviews/Linas.png";
import InesaImg from "../../assets/images/reviews/Inesa.png";

export const REVIEWS_VALUES: {
  id: number;
  comment: string;
  author: string;
  authorTitle: string;
  image?: string;
}[] = [
  {
    id: 4,
    comment:
      "Į Telomerą atėjau su daug klausimų apie savo sveikatą.\nIšėjau su aiškiu planu ir vidine ramybe. Labai vertinu, kad čia\nžiūrima į žmogų visapusiškai, o ne tik per vieną tyrimą",
    author: "Vytautas Šidlauskas",
    authorTitle: "CEO, V&V Investicija",
    image: VytautasImg,
  },
  {
    id: 1,
    comment:
      "Pirmą kartą patyriau, ką reiškia personalizuotos sveikatos\npriežiūros ir prevencijos paslaugos. Tai jau aukštesnio lygio\nmedicina. Visi Telomera komandos nariai, su kuriais teko\nbendrauti, buvo kompetentingi, malonūs ir labai dėmesingi.\nJaučiasi, kad čia ne tik reaguojama į paciento klausimus, bet\nir nuoširdžiai stengiamasi padėti. Linkiu ir toliau taip dirbti bei\nnesustoti",
    author: "Arvydas Sekmokas",
    authorTitle: "Lietuvos politikas",
    image: ArvydasImg,
  },
  {
    id: 2,
    comment:
      "Esu įpratęs sprendimus priimti remdamasis duomenimis,\ntodėl Telomeros požiūris man labai tiko. Patiko, kad nebuvo\nbendrų patarimų - viskas paremta mano rodikliais ir genetika.\nPo konsultacijos turėjau aiškų planą, o ne tik gražią\nataskaitą",
    author: "Mantas Ribelis",
    authorTitle: "CMO, carVertical",
    image: MantasImg,
  },
  {
    id: 3,
    comment:
      "Telomera man - ne dar viena sveikatos paslauga, o\nilgalaikės sveikatos strategijos dalis. Išsiskiria aiškumu,\nstruktūra ir stipriu duomenų pagrindu. Čia ne apie pavienius\ntyrimus - čia apie sisteminį požiūrį į ilgaamžiškumą",
    author: "Dovydas Stulpinas",
    authorTitle: "CEO, Doloop",
    image: DovydasImg,
  },
  {
    id: 5,
    comment:
      "Domiuosi sveikata jau seniai, bet Telomeroje pirmą kartą\npamačiau, kaip mano genetika ir kraujo rodikliai susiję su\nrealiu performance. Dabar aiškiai žinau, ką verta optimizuoti",
    author: "Jonas Skernevičius",
    authorTitle: "Įkūrėjas, Tamsta Profesionalas",
    image: JonasImg,
  },
  {
    id: 6,
    comment:
      "Man svarbiausia - prevencija. Telomera padėjo suprasti, kur\nesu dabar ir ką galiu padaryti, kad ateityje jausčiausi dar\ngeriau",
    author: "Gintvilė Dambravaitė",
    authorTitle: "Įkūrėja, NO MORE accessories",
    image: GintvileImg,
  },
  {
    id: 7,
    comment:
      "Į Telomerą pirmiausia atėjau pati, bet po savo patirties čia\nrūpinasi visa mūsų šeima. Labiausiai vertiname pasitikėjimą,\ngreitą reakciją ir rūpestingą požiūrį",
    author: "Brigita Kriščiūnė",
    authorTitle: "Boardsports partnerė",
    image: BrigitaImg,
  },
  {
    id: 8,
    comment:
      "Labai patiko, kad sprendimai čia ne primetami, o aiškiai\npaaiškinami. Individualus požiūris ir aiškumas - būtent tai, ko\nšiandien dažnai trūksta medicinoje",
    author: "Rūta Vilemienė",
    authorTitle: "CEO, OrtoPro",
    image: RutaImg,
  },
  {
    id: 9,
    comment:
      "Tai buvo daugiau nei tyrimai. Visi mano sveikatos duomenys\nbuvo sujungti į vieną aiškų paveikslą ir paversti realiais,\nlengvai pritaikomais veiksmais",
    author: "Simona Stulpinė",
    authorTitle: "Įkūrėja, Acuamona",
    image: SimonaImg,
  },
  {
    id: 10,
    comment:
      "Didžiausią įspūdį paliko komandos profesionalumas ir\ngebėjimas sudėtingus dalykus paaiškinti paprastai. Jaučiausi\nišgirsta ir suprasta",
    author: "Milana Usarė",
    authorTitle: "Dantų higienistė",
    image: MilanaImg,
  },
  {
    id: 11,
    comment:
      "Telomeroje labiausiai patiko, kad į sveikatą žiūrima kaip į visumą, o ne atskiras problemas. Gavau ne tik tyrimų atsakymus, bet ir aiškų supratimą apie save bei kryptį, kaip judėti toliau. Man kaip mamai labai svarbu, kad galiu ramiai patikėti ir savo vaiko sveikatą - čia jaučiasi profesionalumas, aiškumas ir tikras rūpestis",
    author: "Inesa Burgailė",
    authorTitle: "Verslininkė",
    image: InesaImg,
  },
  {
    id: 12,
    comment:
      "Iki Telomeros turėjau daug atskirų tyrimų, bet trūko bendro vaizdo. Čia visi duomenys buvo sujungti į vieną aiškią visumą ir paversti realiais veiksmais",
    author: "Linas Sinkus",
    authorTitle: "Vyresnysis IT specialistas, emagine",
    image: LinasImg,
  },
  {
    id: 13,
    comment:
      "Kreipiausi, nes jaučiausi pavargusi ir norėjau suprasti, kas vyksta. Gavau aiškius atsakymus ir realius žingsnius - per laiką tikrai pajutau pokytį",
    author: "Emilė Griniūtė",
    authorTitle: "Finansų duomenų vadovė, Vinted",
    image: EmilėImg,
  },
];
